module.exports = __webpack_public_path__ + "img/IMG_5915.3f65e034.webp";